// 메뉴 리스트 중 카테고리 sid
export const MENUSID_CATEGORYSID = 4 as const;
// 메뉴 type 코드별 영문명
export const MENU_TYPE_CODE_TO_ENG = {
  10402: 'Contents',
  10403: 'IR',
  10404: 'Company',
  10405: 'Recruitment',
  10406: 'PR',
  10407: 'Operator Management',
} as const;

export const TEMP_MENU_TYPE_CODE_TO_ENG = [
  { code: 10401, pcode: 104, value: 'Popup' },
  { code: 10405, pcode: 104, value: 'Recruitment' },
  { code: 10402, pcode: 104, value: 'Contents' },
  { code: 10404, pcode: 104, value: 'Company' },
  { code: 10403, pcode: 104, value: 'IR' },
  { code: 10406, pcode: 104, value: 'PR' },
  { code: 10407, pcode: 104, value: 'Operator Management' },
] as const;

export const NAV_BACKGROUND_COLOR = '#212B36';
